window.addEventListener('DOMContentLoaded', () => {
  const parentNavs = document.querySelectorAll('.megamenu-parent-item');

  parentNavs.forEach((parentNav) => {
    parentNav.addEventListener('mouseover', () => {
      if(!parentNav.classList.contains('active')) {
        let handle = parentNav.dataset.target;

        // Activate parent nav
        document.querySelector('.megamenu-parent-item.active').classList.remove('active');
        parentNav.classList.add('active');

        // Activate child navs
        document.querySelector('.megamenu-child-block.active').classList.remove('active');
        document.querySelector(`.megamenu-child-block[data-handle="${handle}"]`).classList.add('active');
      }
    })
  })
})